export { default as VendorsEditForm } from './VendorsEditForm';